import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CardsDTO  {
    _originalTypeClassName = "zERP.BO.CardsDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CardsDTO.translate = translateService;
}
this.Id = null;
this.CardID = null;
this.Active = false;
this.User = null;
this.CardsDTOKey = null;
this._key = this.CardsDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
CardID:any;
Active:any;
User:any;
private _CardsDTOKey:any;
get CardsDTOKey(): any {
    return this._CardsDTOKey;
  }
set CardsDTOKey(value: any) {
    this._CardsDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CardsDTOKey == null || $this.CardsDTOKey == 0;
            }


}